import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { defineAsyncComponent } from "vue";

// Lazy-load PanelGrid so its module (and usePanels inside it) is not evaluated
// until the component is actually rendered. This prevents panels from
// loading for users who are not authorized (since router guards handle this now).

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const PanelGrid = defineAsyncComponent(() => import("@/components/PanelGrid.vue"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PanelGrid))
  ]))
}
}

})